import React, { useState } from 'react';
import './ReviewCard.css';

const ReviewCard = ({ review, onReply, onReport, onDelete }) => {
  const [expanded, setExpanded] = useState(false);
  const [helpfulVoted, setHelpfulVoted] = useState(false);
  const [unhelpfulVoted, setUnhelpfulVoted] = useState(false);
  const [showActionsMenu, setShowActionsMenu] = useState(false);

  const getInitials = (name) => {
    return name.split(' ').map(n => n[0]).join('').toUpperCase().slice(0, 2);
  };

  const renderStars = (rating) => {
    return '⭐'.repeat(rating) + '☆'.repeat(5 - rating);
  };

  const shouldTruncate = review.reviewText.length > 200;
  const displayText = expanded || !shouldTruncate 
    ? review.reviewText 
    : review.reviewText.substring(0, 200) + '...';

  return (
    <div className="review-card">
      <div className="review-card-header">
        <div className="customer-info">
          <div className="customer-avatar">
            {review.customer.photo ? (
              <img src={review.customer.photo} alt={review.customer.name} />
            ) : (
              <span>{getInitials(review.customer.name)}</span>
            )}
          </div>
          <div>
            <div className="customer-name">{review.customer.name}</div>
            {review.customer.verified && (
              <span className="verified-badge">✓ Verified Customer</span>
            )}
          </div>
        </div>
        <div className="review-meta">
          <div className="review-date-time">
            <span>{review.date}</span>
            <span className="time-separator">•</span>
            <span>{review.time}</span>
          </div>
          <div className="actions-menu-wrapper">
            <button
              className="actions-menu-btn"
              onClick={() => setShowActionsMenu(!showActionsMenu)}
            >
              ⋮
            </button>
            {showActionsMenu && (
              <div className="actions-menu-dropdown">
                <button onClick={() => { onReply(); setShowActionsMenu(false); }}>
                  Reply
                </button>
                <button onClick={() => { onReport(); setShowActionsMenu(false); }}>
                  Report
                </button>
                <button onClick={() => { onDelete(); setShowActionsMenu(false); }}>
                  Delete
                </button>
              </div>
            )}
          </div>
        </div>
      </div>

      <div className="review-card-content">
        <div className="order-info">
          <a href={`#order-${review.orderId}`} className="order-link">
            #{review.orderId}
          </a>
          <span className="info-separator">•</span>
          <span className="order-items">{review.items.join(', ')}</span>
        </div>

        <div className="rating-display">
          <span className="stars-rating">{renderStars(review.rating)}</span>
          <span className="rating-number">{review.rating}.0</span>
        </div>

        <div className="review-text">
          {displayText}
          {shouldTruncate && (
            <button
              className="read-more-btn"
              onClick={() => setExpanded(!expanded)}
            >
              {expanded ? 'Read less' : 'Read more'}
            </button>
          )}
        </div>

        {review.photos && review.photos.length > 0 && (
          <div className="review-photos">
            {review.photos.map((photo, i) => (
              <div key={i} className="photo-thumbnail">
                <img src={photo} alt={`Review photo ${i + 1}`} />
              </div>
            ))}
          </div>
        )}

        {review.tags && review.tags.length > 0 && (
          <div className="review-tags">
            {review.tags.map((tag, i) => (
              <span key={i} className="review-tag">{tag}</span>
            ))}
          </div>
        )}

        {review.adminReply && (
          <div className="admin-reply-section">
            <div className="admin-reply-label">Admin Response</div>
            <div className="admin-reply-text">{review.adminReply.text}</div>
            <div className="admin-reply-date">
              {review.adminReply.date} • {review.adminReply.time}
            </div>
          </div>
        )}
      </div>

      <div className="review-card-footer">
        <div className="helpful-section">
          <span className="helpful-question">Was this helpful?</span>
          <button
            className={`helpful-btn ${helpfulVoted ? 'active' : ''}`}
            onClick={() => {
              setHelpfulVoted(!helpfulVoted);
              if (unhelpfulVoted) setUnhelpfulVoted(false);
            }}
          >
            👍 {review.helpfulVotes + (helpfulVoted ? 1 : 0)}
          </button>
          <button
            className={`helpful-btn ${unhelpfulVoted ? 'active' : ''}`}
            onClick={() => {
              setUnhelpfulVoted(!unhelpfulVoted);
              if (helpfulVoted) setHelpfulVoted(false);
            }}
          >
            👎 {review.unhelpfulVotes + (unhelpfulVoted ? 1 : 0)}
          </button>
        </div>
        <div className="admin-actions">
          <button className="action-btn reply-btn" onClick={onReply}>
            💬 Reply
          </button>
          <button className="action-btn report-btn" onClick={onReport}>
            🚩 Report
          </button>
          <button className="action-btn delete-btn" onClick={onDelete}>
            🗑️ Delete
          </button>
        </div>
      </div>
    </div>
  );
};

export default ReviewCard;

